import * as api from "services/api";
import { getErrors } from "helpers/error";

import _ from "lodash";
import { Dispatch } from "redux";

export const GET_HOME = "[HOME] GET_HOME";
export const GET_HOME_SUCCESS = "[HOME] GET_HOME_SUCCESS";
export const GET_HOME_FAILED = "[HOME] GET_HOME_FAILED";

export const SET_VALUE = "[HOME] SET_VALUE";
export const CLEAR_VALUES = "[HOME] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getDashboard() {
    return async (dispatch: Dispatch, getState: any) => {
        dispatch({
            type: GET_HOME
        });

        try {
            const { login } = getState();

            const response = await api.sendGet(`/Mei/Dashboard`, {
                Authorization: "Bearer " + login.token
            });

            const result = await response.json();

            if (result.isValid) {
                dispatch({
                    type: GET_HOME_SUCCESS,
                    payload: result.model
                });
            } else {
                dispatch({
                    type: GET_HOME_FAILED,
                    payload: getErrors(result.errors)
                });
            }
        } catch (error) {
            dispatch({
                type: GET_HOME_FAILED,
                payload: {
                    error: "Connection error"
                }
            });
        }
    };
}